
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9d42Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "HIDDEN", () => $020697dd75636f04$export$d2f7b3f0efb6e208);
$parcel$export(module.exports, "DISMISSED", () => $020697dd75636f04$export$6a4add537aaf5560);
$parcel$export(module.exports, "MILLISECONDS_IN_A_DAY", () => $020697dd75636f04$export$98a7370239de6730);
$parcel$export(module.exports, "default", () => $020697dd75636f04$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $79nXx = parcelRequire("79nXx");

var $kUxFz = parcelRequire("kUxFz");

var $i8Qvm = parcelRequire("i8Qvm");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $ex8CH = parcelRequire("ex8CH");

var $cuIMo = parcelRequire("cuIMo");

var $gZkaf = parcelRequire("gZkaf");
const $020697dd75636f04$export$d2f7b3f0efb6e208 = 'HIDDEN';
const $020697dd75636f04$export$6a4add537aaf5560 = 'DISMISSED';
const $020697dd75636f04$export$98a7370239de6730 = 1440000;
const $020697dd75636f04$var$CUSTOM_DOMAIN_CHANGE_BOARDING_FLAG_ID = (0, $7HGHK.toFlagId)('jsm-custom-domain-change-boarding-flag');
const $020697dd75636f04$var$deactivatedLearnMoreLink = 'https://support.atlassian.com/organization-administration/docs/remove-or-deactivate-a-custom-domain/';
const $020697dd75636f04$var$JsmCustomDomainChangeBoardingFlag = ()=>{
    const currentTime = Date.now();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const [showModal, setShowModal] = (0, $5uXOq.useState)(false);
    const [modalState, setModalState] = (0, $5uXOq.useState)($020697dd75636f04$export$d2f7b3f0efb6e208);
    const [{ userSeenFlagDate: userSeenFlagDate, showFlagUpdateStartDate: showFlagUpdateStartDate, helpCenterUrls: helpCenterUrls, customDomainStatus: customDomainStatus }, { updateUserProperty: updateUserProperty, fetchApplicationProperty: fetchApplicationProperty, fetchSeenFlagDateProperty: fetchSeenFlagDateProperty }] = (0, $ex8CH.useProperties)();
    const onDismissed = (id, analyticsEvent)=>{
        dismissFlag($020697dd75636f04$var$CUSTOM_DOMAIN_CHANGE_BOARDING_FLAG_ID);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customDomainChangeBoardingFlag');
        updateUserProperty();
    };
    const onClick = ()=>{
        if (customDomainStatus === 'ACTIVE') {
            setShowModal(true);
            setFlagShown(true);
            dismissFlag($020697dd75636f04$var$CUSTOM_DOMAIN_CHANGE_BOARDING_FLAG_ID);
        }
        if (customDomainStatus === 'INACTIVE') {
            updateUserProperty();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open($020697dd75636f04$var$deactivatedLearnMoreLink, '_blank');
        }
    };
    const onClose = (e, analyticsEvent)=>{
        setShowModal(false);
        setModalState($020697dd75636f04$export$6a4add537aaf5560);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customDomainChangeBoardingGotIt');
        updateUserProperty();
    };
    const timeStampToDate = (timestamp)=>new Date(timestamp);
    (0, $5uXOq.useEffect)(()=>{
        Promise.all([
            fetchApplicationProperty(),
            fetchSeenFlagDateProperty()
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        const pollInterval = setInterval(()=>Promise.all([
                fetchApplicationProperty(),
                fetchSeenFlagDateProperty()
            ]), $020697dd75636f04$export$98a7370239de6730);
        return ()=>clearInterval(pollInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (showModal && helpCenterUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZkaf.UrlUpdateDialog), {
        onClose: onClose,
        helpCenterUrls: helpCenterUrls
    }));
    if (modalState === $020697dd75636f04$export$6a4add537aaf5560) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null);
    if (flagShown || helpCenterUrls === undefined || customDomainStatus === undefined) return null;
    if (userSeenFlagDate === (0, $ex8CH.NOT_LOADED) || showFlagUpdateStartDate === (0, $ex8CH.NOT_LOADED)) return null;
    if (showFlagUpdateStartDate === (0, $ex8CH.NO_VALUE)) return null;
    if ((0, $kUxFz.default)(timeStampToDate(currentTime), timeStampToDate(showFlagUpdateStartDate)) || userSeenFlagDate !== (0, $ex8CH.NO_VALUE) && (0, $79nXx.default)(timeStampToDate(userSeenFlagDate), timeStampToDate(showFlagUpdateStartDate))) return null;
    showFlag({
        id: $020697dd75636f04$var$CUSTOM_DOMAIN_CHANGE_BOARDING_FLAG_ID,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cuIMo.FlagInner), {
                ...props,
                onDismissed: onDismissed,
                onClick: onClick,
                status: customDomainStatus,
                helpCenterUrls: helpCenterUrls,
                messageId: `help-center-custom-domain-change-boarding.ui.flag-inner.${$020697dd75636f04$var$CUSTOM_DOMAIN_CHANGE_BOARDING_FLAG_ID}`,
                messageType: "transactional"
            })
    });
    setFlagShown(true);
    return null;
};
var $020697dd75636f04$export$2e2bcd8739ae039 = $020697dd75636f04$var$JsmCustomDomainChangeBoardingFlag;

});
parcelRegister("ex8CH", function(module, exports) {

$parcel$export(module.exports, "NOT_LOADED", () => $4ceccd054bbaa79c$export$256d135b6d6cdabe);
$parcel$export(module.exports, "NO_VALUE", () => $4ceccd054bbaa79c$export$d5a265bcf7e0ecc1);
$parcel$export(module.exports, "useProperties", () => $4ceccd054bbaa79c$export$b003fb77901c7fe3);

var $5uXOq = parcelRequire("5uXOq");

var $bFU4G = parcelRequire("bFU4G");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $9OXo1 = parcelRequire("9OXo1");

const $4ceccd054bbaa79c$export$256d135b6d6cdabe = 'NOT_LOADED';
const $4ceccd054bbaa79c$export$d5a265bcf7e0ecc1 = 'NO_VALUE';
const $4ceccd054bbaa79c$var$EXPECTED_ERROR_STATUS = [
    403,
    404
];
const $4ceccd054bbaa79c$export$b003fb77901c7fe3 = ()=>{
    const currentTime = Date.now();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [showFlagUpdateStartDate, setShowFlagUpdateStartDate] = (0, $5uXOq.useState)($4ceccd054bbaa79c$export$256d135b6d6cdabe);
    const [helpCenterUrls, setHelpcenterUrls] = (0, $5uXOq.useState)(undefined);
    const [customDomainStatus, setCustomDomainStatus] = (0, $5uXOq.useState)(undefined);
    const [userSeenFlagDate, setUserSeenFlagDate] = (0, $5uXOq.useState)($4ceccd054bbaa79c$export$256d135b6d6cdabe);
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleErrorLogging = (0, $5uXOq.useCallback)((operation, e)=>{
        setLoading(false);
        if (e.name === 'FetchError' && !$4ceccd054bbaa79c$var$EXPECTED_ERROR_STATUS.includes(e.statusCode)) {
            (0, $jcw0u.default)({
                meta: {
                    id: operation,
                    packageName: (0, $a714ef406a66d2e3$export$b8b9d90f9e5bd72b),
                    teamName: (0, $a714ef406a66d2e3$export$d57b6b390e78d90f)
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(e);
        }
    }, []);
    const fetchSeenFlagDateProperty = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId && userSeenFlagDate === $4ceccd054bbaa79c$export$256d135b6d6cdabe) {
            setLoading(true);
            try {
                const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $a714ef406a66d2e3$export$a7741d60828dd6c));
                setLoading(false);
                setUserSeenFlagDate(Number(response));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setUserSeenFlagDate($4ceccd054bbaa79c$export$d5a265bcf7e0ecc1);
                handleErrorLogging((0, $a714ef406a66d2e3$export$9c32917917adce6b), e);
            }
        }
    }, [
        atlassianAccountId,
        handleErrorLogging,
        loading,
        userSeenFlagDate
    ]);
    const updateUserProperty = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId) {
            setLoading(true);
            try {
                await (0, $89SaW.setUserProperties)(atlassianAccountId, (0, $a714ef406a66d2e3$export$a7741d60828dd6c), currentTime.toString());
                setLoading(false);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                handleErrorLogging((0, $a714ef406a66d2e3$export$622e359c4ee54143), e);
            }
        }
    }, [
        atlassianAccountId,
        currentTime,
        handleErrorLogging,
        loading
    ]);
    const fetchApplicationProperty = (0, $5uXOq.useCallback)(async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            const fetchStartTime = performance.now();
            const response = await (0, $eusud.performGetRequest)('/rest/servicedesk/1/customdomain');
            (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/1/customdomain', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            const { startDate: startDate, newUrl: newUrl, oldUrl: oldUrl, status: status } = response;
            setLoading(false);
            setShowFlagUpdateStartDate(startDate);
            setHelpcenterUrls({
                newUrl: newUrl,
                oldUrl: oldUrl
            });
            setCustomDomainStatus(status);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setShowFlagUpdateStartDate($4ceccd054bbaa79c$export$d5a265bcf7e0ecc1);
            handleErrorLogging((0, $a714ef406a66d2e3$export$3fbedbe58601db04), e);
        }
    }, [
        handleErrorLogging,
        loading
    ]);
    const memoisedData = (0, $5uXOq.useMemo)(()=>({
            userSeenFlagDate: userSeenFlagDate,
            showFlagUpdateStartDate: showFlagUpdateStartDate,
            helpCenterUrls: helpCenterUrls,
            customDomainStatus: customDomainStatus,
            loading: loading,
            error: error
        }), [
        userSeenFlagDate,
        showFlagUpdateStartDate,
        loading,
        error,
        helpCenterUrls,
        customDomainStatus
    ]);
    return [
        memoisedData,
        {
            fetchSeenFlagDateProperty: fetchSeenFlagDateProperty,
            updateUserProperty: updateUserProperty,
            fetchApplicationProperty: fetchApplicationProperty
        }
    ];
};

});
const $a714ef406a66d2e3$export$a7741d60828dd6c = 'jsm.custom.domain.flag.seen.date';
const $a714ef406a66d2e3$export$b8b9d90f9e5bd72b = 'jiraHelpCenterCustomDomainChangeBoarding';
const $a714ef406a66d2e3$export$d57b6b390e78d90f = 'jsm-banana';
const $a714ef406a66d2e3$export$9c32917917adce6b = 'fetchUserProperty';
const $a714ef406a66d2e3$export$622e359c4ee54143 = 'updateUserProperty';
const $a714ef406a66d2e3$export$3fbedbe58601db04 = 'getShowFlagDate';


parcelRegister("cuIMo", function(module, exports) {

$parcel$export(module.exports, "FlagInner", () => $1d458ad72303f480$export$aee024ba3b3f9d72);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $3ZC89 = parcelRequire("3ZC89");

var $dS3PR = parcelRequire("dS3PR");

var $d4xRU = parcelRequire("d4xRU");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $i43Rr = parcelRequire("i43Rr");
const $1d458ad72303f480$var$Bold = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "strong"
    }, props.children);
const $1d458ad72303f480$export$aee024ba3b3f9d72 = (props)=>{
    const { onDismissed: onDismissed, onClick: onClick, status: status, helpCenterUrls: helpCenterUrls, messageId: messageId = 'help-center-custom-domain-change-boarding.ui.flag-inner.flag', messageType: messageType = 'transactional' } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: "jsm-custom-domain-change-boarding-flag",
        icon: status === 'ACTIVE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-accent-purple, #8270DB)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-brand, #0C66E4)"
        }),
        title: status === 'ACTIVE' ? formatMessage((0, $i43Rr.default).flagTitle) : formatMessage((0, $i43Rr.default).flagTitleInactive),
        description: status === 'ACTIVE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
            message: formatMessage((0, $i43Rr.default).flagDescription, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            }),
            componentsMapping: {
                bold: $1d458ad72303f480$var$Bold
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
            message: formatMessage((0, $i43Rr.default).flagDescriptionInactive, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}',
                oldUrl: helpCenterUrls.oldUrl,
                newUrl: helpCenterUrls.newUrl
            }),
            componentsMapping: {
                bold: $1d458ad72303f480$var$Bold
            }
        }),
        messageId: messageId,
        messageType: messageType,
        actions: [
            {
                ...status === 'ACTIVE' ? {
                    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $i43Rr.default).flagActionContent)),
                    onClick: onClick
                } : {
                    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $i43Rr.default).flagActionContentInactivateOrRemove), " "),
                    onClick: onClick
                }
            }
        ],
        onDismissed: onDismissed
    });
};

});
parcelRegister("d4xRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61381db0e069bc03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3mcNI")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("3mcNI")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $kxZPA.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("a8Hbj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $kxZPA.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("a8Hbj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("3mcNI", function(module, exports) {

let $271d5b247e07d49f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $271d5b247e07d49f$var$load("kNFvF"),
    $271d5b247e07d49f$var$load("ffQaD"),
    $271d5b247e07d49f$var$load("kvRbA"),
    $271d5b247e07d49f$var$load("76n7a"),
    $271d5b247e07d49f$var$load("l253H"),
    $271d5b247e07d49f$var$load("eH8ke")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("a8Hbj", function(module, exports) {

let $761c25b21fad9e16$var$load = (parcelRequire("28QjX"))(4);
module.exports = $761c25b21fad9e16$var$load("1PJIF").then(()=>parcelRequire('5pz6a'));

});



parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("i43Rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c272029e7ebb65$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $30c272029e7ebb65$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "help-center-custom-domain-change-boarding.flag-inner.flag-title",
        "defaultMessage": "Admin has set a new help center URL"
    },
    flagDescription: {
        "id": "help-center-custom-domain-change-boarding.flag-inner.flag-description",
        "defaultMessage": "Discover the new URL under {boldStart}Channels{boldEnd}. Customers using the previous URL will be redirected to the new one."
    },
    flagActionContent: {
        "id": "help-center-custom-domain-change-boarding.flag-inner.flag-action-content",
        "defaultMessage": "Learn more about this change"
    },
    flagTitleInactive: {
        "id": "help-center-custom-domain-change-boarding.flag-inner.flag-title-inactive",
        "defaultMessage": "Admin has reverted your help center URL"
    },
    flagDescriptionInactive: {
        "id": "help-center-custom-domain-change-boarding.flag-inner.flag-description-inactive",
        "defaultMessage": "Your admin either deactivated or removed the {boldStart}{oldUrl}{boldEnd} custom domain used by this help center. Customers will need to use the default URL {boldStart}{newUrl}{boldEnd}"
    },
    flagActionContentInactive: {
        "id": "help-center-custom-domain-change-boarding.flag-inner.flag-action-content-inactive",
        "defaultMessage": "Learn about deactivated or removed domain"
    },
    flagActionContentInactivateOrRemove: {
        "id": "help-center-custom-domain-change-boarding.flag-inner.flag-action-content-inactivate-or-remove",
        "defaultMessage": "About inactive and removed domains"
    }
});

});


parcelRegister("gZkaf", function(module, exports) {

$parcel$export(module.exports, "UrlUpdateDialog", () => $dd16841295a72c97$export$360ab00be51c5a8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $fVnbM = parcelRequire("fVnbM");

var $2x3Cb = parcelRequire("2x3Cb");

var $3u0c5 = parcelRequire("3u0c5");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $kY99m = parcelRequire("kY99m");

var $4R6GH = parcelRequire("4R6GH");

var $7NYq5 = parcelRequire("7NYq5");

var $koVbs = parcelRequire("koVbs");

var $andOr = parcelRequire("andOr");
const $dd16841295a72c97$export$360ab00be51c5a8 = ({ onClose: onClose, helpCenterUrls: helpCenterUrls })=>{
    const { newUrl: newUrl, oldUrl: oldUrl } = helpCenterUrls;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "help-center-custom-domain-change-boarding.ui.url-update-dialog.modal-dialog",
        messageType: "transactional",
        key: "help-center-url-update",
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $andOr.default).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd16841295a72c97$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd16841295a72c97$var$LabelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "custom-domain-url"
    }, formatMessage((0, $andOr.default).customDomainUrlLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $andOr.default).newUrl))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd16841295a72c97$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        value: newUrl,
        isReadOnly: true,
        appearance: "standard",
        id: "custom-domain-url"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd16841295a72c97$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "default-url"
    }, formatMessage((0, $andOr.default).defaultUrlLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd16841295a72c97$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        value: oldUrl,
        isReadOnly: true,
        appearance: "standard",
        id: "default-url"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd16841295a72c97$var$ModalDescription, null, formatMessage((0, $andOr.default).modalDescription)), (0, $4R6GH.fg)('replace-anchor-with-link__jsm-banana') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        target: "_blank",
        href: "https://support.atlassian.com/organization-administration/docs/update-your-product-and-site-url"
    }, formatMessage((0, $andOr.default).linkLearnMoreCustomDomain)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        target: "_blank",
        href: "https://support.atlassian.com/organization-administration/docs/update-your-product-and-site-url"
    }, formatMessage((0, $andOr.default).linkLearnMoreCustomDomain))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        autoFocus: true,
        appearance: "primary",
        onClick: onClose
    }, formatMessage((0, $andOr.default).acknowledgeUpdateButton))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dd16841295a72c97$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv77o _u5f3v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dd16841295a72c97$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _n3tdv77o",
            __cmplp.className
        ])
    });
});
const $dd16841295a72c97$var$TextFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi _18y1131l _1yy71wq8",
            __cmplp.className
        ])
    });
});
const $dd16841295a72c97$var$ModalDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("kY99m", function(module, exports) {

$parcel$export(module.exports, "default", () => $509076ff0c6afa78$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $509076ff0c6afa78$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $509076ff0c6afa78$var$inputMediaDisabled = null;
const $509076ff0c6afa78$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $509076ff0c6afa78$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $509076ff0c6afa78$var$invalidStyle = null;
const $509076ff0c6afa78$var$focusWithinStyle = {
    standard: "_1p9x1p6i _qao9r01l _q433q049",
    subtle: "_1p9x1p6i _qao9r01l _q433q049",
    none: "_1p9x3acm _qao918uv _q433nruj"
};
const $509076ff0c6afa78$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $509076ff0c6afa78$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _msj6gir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _msj6gir2"
};
const $509076ff0c6afa78$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $509076ff0c6afa78$var$getMaxWidth = (width)=>!width ? `100%` : width in $509076ff0c6afa78$var$widthMap ? `${$509076ff0c6afa78$var$widthMap[width]}px` : `${+width}px`;
const $509076ff0c6afa78$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $509076ff0c6afa78$var$containerStyles = null;
const $509076ff0c6afa78$var$inputDisabledStyle = null;
const $509076ff0c6afa78$var$inputCompactStyleWithFg = null;
const $509076ff0c6afa78$var$inputCompactStyle = null;
const $509076ff0c6afa78$var$inputMonospacedStyle = null;
const $509076ff0c6afa78$var$inputFontStyleWithFG = null;
const $509076ff0c6afa78$var$inputStyleMonospacedWithFg = null;
const $509076ff0c6afa78$var$inputStyleNotDataCompactWithFG = null;
const $509076ff0c6afa78$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $509076ff0c6afa78$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$509076ff0c6afa78$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $509076ff0c6afa78$var$getContainerTextBgAndBorderColor[appearance],
            $509076ff0c6afa78$var$containerStyleAppearance[appearance],
            !isDisabled && $509076ff0c6afa78$var$focusWithinStyle[appearance],
            !isDisabled && $509076ff0c6afa78$var$hoverStyle[appearance],
            isDisabled && $509076ff0c6afa78$var$containerMedia.disabled,
            isDisabled && $509076ff0c6afa78$var$disabledStyle[appearance],
            isInvalid && $509076ff0c6afa78$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;

});

parcelRegister("andOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $19abdcf3a30f9c52$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $19abdcf3a30f9c52$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalTitle: {
        "id": "help-center-custom-domain-change-boarding.url-update-dialog.modal-title",
        "defaultMessage": "Help center URL update"
    },
    modalDescription: {
        "id": "help-center-custom-domain-change-boarding.url-update-dialog.modal-description",
        "defaultMessage": "We'll redirect the default help center URL and portal URLs to improve your customers' portal experience. Your project's email addresses won't be affected and will continue to receive and send emails as usual."
    },
    newUrl: {
        "id": "help-center-custom-domain-change-boarding.url-update-dialog.new-url",
        "defaultMessage": "ACTIVE"
    },
    customDomainUrlLabel: {
        "id": "help-center-custom-domain-change-boarding.url-update-dialog.custom-domain-url-label",
        "defaultMessage": "Custom domain URL"
    },
    defaultUrlLabel: {
        "id": "help-center-custom-domain-change-boarding.url-update-dialog.default-url-label",
        "defaultMessage": "Default URL"
    },
    acknowledgeUpdateButton: {
        "id": "help-center-custom-domain-change-boarding.url-update-dialog.acknowledge-update-button",
        "defaultMessage": "Got it"
    },
    linkLearnMoreCustomDomain: {
        "id": "help-center-custom-domain-change-boarding.url-update-dialog.link-learn-more-custom-domain",
        "defaultMessage": "Learn more about configuring custom URLs for your Atlassian products"
    }
});

});




//# sourceMappingURL=async-jsm-custom-domain-change-boarding-flag.6ab668b0.js.map
